import { section } from "@/js/glow";
import { animateBlogPosts, shouldAnimate } from "@/js/lib/animation";
import {contains, listen, qs, qsa} from "@fluorescent/dom";
import Carousel from "@/js/lib/carousel.js";

const selectors = {
  sliderContainer: ".carousel",
  scrollBar: ".carousel__scrollbar",
};

section("blog-posts", {
  onLoad() {
    this._initCarousels();

    if (shouldAnimate(this.container)) {
      this.animateBlogPosts = animateBlogPosts(this.container);
    }
  },

  _initCarousels() {
    const { postsPerView, mobilePostsPerView, showSliders } = this.container.dataset;
    this.perView = parseInt(postsPerView, 10);
    this.mobilePerView = parseInt(mobilePostsPerView, 10) * 1.085;

    const carouselsElement = qs(selectors.sliderContainer, this.container);
    const scrollBarElement = qs(selectors.scrollBar, this.container);

    if (showSliders === 'true') {
      Carousel(carouselsElement, {
        slidesPerView: this.mobilePerView,
        spaceBetween: 20,
        scrollbar: {
          el: scrollBarElement,
          draggable: true,
        },
        breakpoints: {
          720: {
            slidesPerView:
              this.perView === 5 ? this.perView - 1 : this.perView,
          },
          1200: {
            slidesPerView: this.perView,
          },
        },
      })
    }
  },

  onUnload() {
    this.animateBlogPosts?.destroy();
  },
});